var $69b41140b9a4ca54$exports = {};
$69b41140b9a4ca54$exports = {
  "decrease": function decrease(args) {
    return "Smanji ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Pove\u0107aj ".concat(args.fieldLabel);
  },
  "numberField": "Polje broja"
};
export { $69b41140b9a4ca54$exports as default };